import { useLinkageAmount, useLinkageBusinessAPI } from '../LinkageCreationContext'
import CustomButton from '../../../../../ui/CustomButton'
import { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../../../../context/global-context'
import { Title } from '../../../../../ui'
import ResizableModal from '../../../../../ui/ResizableModal'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'

const InputField = ({ label, placeholder, type, value, onChange, disabled = false }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`mt-1 block w-full rounded-full border-gray-300 shadow-sm sm:text-sm font-sans
        ${
          disabled
            ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
            : 'focus:border-indigo-500 focus:ring-indigo-500'
        }
      `}
    />
  </div>
)

const TextAreaField = ({ label, value, onChange, ...props }) => (
  <div>
    <label className='block text-sm font-sans font-medium text-gray-700'>{label}</label>
    <textarea
      className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans'
      value={value}
      onChange={onChange}
      maxLength={50}
      required
      {...props}
    />
    <p className='text-xs text-gray-500 mt-1'>{value.length}/50 caracteres</p>
  </div>
)

const DevolucionImpuestos = ({
  open,
  setOpen,
  type = 'ingreso',
  setSwitchDate,
  idLibro,
  fVenc,
  folio,
  action
}) => {
  const [movimientoSeleccionado] = useState(null)
  const [fecha, setFecha] = useState('')
  const [, setVencimiento] = useState('')
  const [glosa, setGlosa] = useState('')
  const [monto, setMonto, bankAmountLocked] = useLinkageAmount('')

  const razonSocial = 'Servicios Impuestos Internos'
  const businessAPI = useLinkageBusinessAPI()
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)

  const handleClose = () => setOpen(false)

  const functionGetData = async () => {
    try {
      setLoading(true)
      const response = await organizationAPI.getDataLibroContable(
        currentBusiness?.id,
        idLibro,
        type.trim()
      )
      setData(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open && idLibro) {
      functionGetData()
    }
  }, [open, idLibro])

  useEffect(() => {
    if (data) {
      if (data.fecha) {
        const parsedDate = new Date(data.fecha)
        const formattedDate = parsedDate.toISOString().split('T')[0]
        setFecha(formattedDate)
      }
      if (data.fechaVencimiento) {
        const parsedDate = new Date(data.fechaVencimiento)
        const formattedDate = parsedDate.toISOString().split('T')[0]
        setVencimiento(formattedDate)
      }
      if (data.glosa) setGlosa(data.glosa)
      if (data.montoTotal) setMonto(data.montoTotal.toString())
    }
  }, [data])

  const handleDatos = async () => {
    if (!fecha || !monto || !glosa) {
      alert('Todos los campos son obligatorios excepto folio')
      return
    }
    const payload = {
      fecha: fecha,
      transaccionId: action === 'replicar' ? null : movimientoSeleccionado?.id,
      razonSocial: razonSocial || null,
      nombreComprobante: null,
      nombreComprobanteId: null,
      glosa: glosa || null,
      respaldoId: null,
      monto: Number(monto)
    }
    try {
      setLoading(true)
      const response = await businessAPI.postPagoArriendo(
        currentBusiness.id,
        payload,
        'devolucion-de-impuestos'
      )
      console.info(response)
      setSwitchDate(true)
      handleClose()
    } catch (error) {
      console.error('Error al agregar comprobante:', error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const payload = {
        fecha,
        glosa,
        monto: Number(monto),
        razonSocial,
        nombreComprobante: data.nombreCodigoDocumento
      }

      await organizationAPI.updateVinculacion(currentBusiness.id, idLibro, payload)
      setSwitchDate(true)
      functionGetData()
      handleClose()
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const formatMonto = value => {
    if (!value) return ''
    const numericValue = value.replace(/\D/g, '')
    if (!numericValue) return ''
    return new Intl.NumberFormat('es-CL').format(numericValue)
  }

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]
    setFecha(today)
    setVencimiento(today)
  }, [])

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      footer={
        <>
          <CustomButton
            title='CANCELAR'
            color='primary'
            className='rounded-full'
            onClick={handleClose}
          />
          <CustomButton
            title={
              action === 'replicar'
                ? 'REPLICAR VINCULACIÓN'
                : action === 'modificar'
                  ? 'GRABAR VINCULACIÓN'
                  : 'GRABAR VINCULACIÓN'
            }
            color='accent2'
            className='rounded-full'
            disabled={loading}
            onClick={action === 'modificar' ? handleSubmit : handleDatos}
          />
        </>
      }
    >
      <>
        {loading ? (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
          </Box>
        ) : (
          <>
            <div className='mt-4'>
              <div className='flex justify-between items-center mb-6'>
                <div>
                  <Title className='text-3xl font-sans'>Devolución de Impuestos</Title>
                </div>
              </div>
              <div className="flex w-full items-start h-full p-6 bg-white rounded-lg shadow-md'">
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 w-full'>
                  <InputField label='Folio' value={folio} type='text' disabled />
                  <div>
                    <label className='block text-sm font-sans font-medium text-gray-700'>
                      Fecha
                    </label>
                    <input
                      type='date'
                      value={fecha}
                      onChange={e => setFecha(e.target.value)}
                      className='mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm font-sans'
                    />
                  </div>
                  <InputField label='Institución' type='text' value={razonSocial} disabled />
                  <InputField
                    disabled={bankAmountLocked}
                    label='Monto'
                    placeholder='$'
                    type='text'
                    value={formatMonto(monto)}
                    onChange={e => setMonto(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                  <InputField
                    label='Clasificación'
                    placeholder='1-1-9-1 Pagos Provisionales Mensuales (PPM)'
                    type='text'
                    disabled
                  />
                  <TextAreaField
                    label='Detalle'
                    placeholder='Describe en detalle la naturaleza, origen o lo que mejor describa la vinculación que vamos a crear.'
                    value={glosa}
                    onChange={e => setGlosa(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </ResizableModal>
  )
}

export default DevolucionImpuestos
